import { createAsyncAction, createStandardAction } from 'typesafe-actions'
import {
  UserListReq,
  UserListRes,
  MerchantRolesReq,
  MerchantRolesRes,
  CreateUserReq,
  ActionRes,
  UserDetailReq,
  UserDetailRes,
  UpdateUserReq,
  ResetPasswordReq,
  UserStatusReq,
  DeleteUserReq,
} from './types'

export const getStaffListAction = createAsyncAction(
  'MANAGE_USER/GET_STAFF_LIST_REQ',
  'MANAGE_USER/GET_STAFF_LIST_SUCCESS',
  'MANAGE_USER/GET_STAFF_LIST_FAILURE',
)<UserListReq, UserListRes, Error>()

export const getMerchantRoleAction = createAsyncAction(
  'MANAGE_USER/GET_MERCHANT_ROLE_LIST_REQ',
  'MANAGE_USER/GET_MERCHANT_ROLE_LIST_SUCCESS',
  'MANAGE_USER/GET_MERCHANT_ROLE_LIST_FAILURE',
)<MerchantRolesReq, MerchantRolesRes, Error>()

export const createAction = createAsyncAction(
  'MANAGE_USER/CREATE_STAFF_REQ',
  'MANAGE_USER/CREATE_STAFF_SUCCESS',
  'MANAGE_USER/CREATE_STAFF_FAILURE',
)<CreateUserReq, ActionRes, Error>()

export const updateAction = createAsyncAction(
  'MANAGE_USER/UPDATE_STAFF_REQ',
  'MANAGE_USER/UPDATE_STAFF_SUCCESS',
  'MANAGE_USER/UPDATE_STAFF_FAILURE',
)<UpdateUserReq, ActionRes, Error>()

export const getDetailAction = createAsyncAction(
  'MANAGE_USER/GET_STAFF_DETAIL_REQ',
  'MANAGE_USER/GET_STAFF_DETAIL_SUCCESS',
  'MANAGE_USER/GET_STAFF_DETAIL_FAILURE',
)<UserDetailReq, UserDetailRes, Error>()

export const resetPasswordAction = createAsyncAction(
  'MANAGE_USER/RESET_STAFF_PIN_REQ',
  'MANAGE_USER/RESET_STAFF_PIN_SUCCESS',
  'MANAGE_USER/RESET_STAFF_PIN_FAILURE',
)<ResetPasswordReq, ActionRes, Error>()

export const updateStatusAction = createAsyncAction(
  'MANAGE_USER/UPDATE_STAFF_STATUS_REQ',
  'MANAGE_USER/UPDATE_STAFF_STATUS_SUCCESS',
  'MANAGE_USER/UPDATE_STAFF_STATUS_FAILURE',
)<UserStatusReq, ActionRes, Error>()

export const deleteAction = createAsyncAction(
  'MANAGE_USER/DELETE_STAFF_REQ',
  'MANAGE_USER/DELETE_STAFF_SUCCESS',
  'MANAGE_USER/DELETE_STAFF_FAILURE',
)<DeleteUserReq, ActionRes, Error>()

// export const getRolesListAction = createAsyncAction(
//   'POS/GET_ROLES_LIST_REQ',
//   'POS/GET_ROLES_LIST_SUCCESS',
//   'POS/GET_ROLES_LIST_FAILURE',
// )<StaffRolesReq, StaffRolesRes, Error>()

// export const getDetailAction = createAsyncAction(
//   'POS/GET_STAFF_DETAIL_REQ',
//   'POS/GET_STAFF_DETAIL_SUCCESS',
//   'POS/GET_STAFF_DETAIL_FAILURE',
// )<StaffDetailReq, StaffDetailRes, Error>()

// export const createAction = createAsyncAction(
//   'POS/CREATE_STAFF_REQ',
//   'POS/CREATE_STAFF_SUCCESS',
//   'POS/CREATE_STAFF_FAILURE',
// )<CreateStaffReq, ActionRes, Error>()

// export const updateAction = createAsyncAction(
//   'POS/UPDATE_STAFF_REQ',
//   'POS/UPDATE_STAFF_SUCCESS',
//   'POS/UPDATE_STAFF_FAILURE',
// )<UpdateStaffReq, ActionRes, Error>()

// export const resetPinAction = createAsyncAction(
//   'POS/RESET_STAFF_PIN_REQ',
//   'POS/RESET_STAFF_PIN_SUCCESS',
//   'POS/RESET_STAFF_PIN_FAILURE',
// )<ResetPinReq, ActionRes, Error>()

// export const deleteAction = createAsyncAction(
//   'POS/DELETE_STAFF_REQ',
//   'POS/DELETE_STAFF_SUCCESS',
//   'POS/DELETE_STAFF_FAILURE',
// )<DeleteStaffReq, ActionRes, Error>()

// export const updateStaffStatusAction = createAsyncAction(
//   'POS/UPDATE_STAFF_STATUS_REQ',
//   'POS/UPDATE_STAFF_STATUS_SUCCESS',
//   'POS/UPDATE_STAFF_STATUS_FAILURE',
// )<StaffStatusReq, ActionRes, Error>()

// export const getMerchantPackageListAction = createAsyncAction(
//   'POS/GET_MERCHANT_PACKAGE_LIST_REQ',
//   'POS/GET_MERCHANT_PACKAGE_LIST_SUCCESS',
//   'POS/GET_MERCHANT_PACKAGE_LIST_FAILURE',
// )<MerchantPackageListReq, MerchantPackageListRes, Error>()

// export const getPackagesSpecAction = createAsyncAction(
//   'POS/GET_PACKAGES_SPEC_REQ',
//   'POS/GET_PACKAGES_SPEC_SUCCESS',
//   'POS/GET_PACKAGES_SPEC_FAILURE',
// )<PackagesSpecReq, PackagesSpecRes, Error>()

// export const getPackagesSpecByIDAction = createAsyncAction(
//   'POS/GET_PACKAGES_SPEC_BY_ID_REQ',
//   'POS/GET_PACKAGES_SPEC_BY_ID_SUCCESS',
//   'POS/GET_PACKAGES_SPEC_BY_ID_FAILURE',
// )<PackagesSpecByIDReq, PackagesSpecByIDRes, Error>()

// export const buyPackageAction = createAsyncAction(
//   'POS/BUY_PACKAGE_REQ',
//   'POS/BUY_PACKAGE_SUCCESS',
//   'POS/BUY_PACKAGE_FAILURE',
// )<PackagesRegisReq, ActionRes, Error>()

// export const renewPackageAction = createAsyncAction(
//   'POS/RENEW_PACKAGE_REQ',
//   'POS/RENEW_PACKAGE_SUCCESS',
//   'POS/RENEW_PACKAGE_FAILURE',
// )<PackagesRegisReq, ActionRes, Error>()

// export const activatePackageAction = createAsyncAction(
//   'POS/ACTIVATE_PACKAGE_REQ',
//   'POS/ACTIVATE_PACKAGE_SUCCESS',
//   'POS/ACTIVATE_PACKAGE_FAILURE',
// )<ActivateReq, ActionRes, Error>()

// export const getPackagesLogAction = createAsyncAction(
//   'POS/GET_PACKAGES_LOGS_REQ',
//   'POS/GET_PACKAGES_LOGS_SUCCESS',
//   'POS/GET_PACKAGES_LOGS_FAILURE',
// )<PackageLogReq, PackageLogRes, Error>()

export const clearEventAction = createStandardAction('MANAGE_USER/CLEAR_EVENT')<void>()
